// extracted by mini-css-extract-plugin
export default {"parent":"formCheckbox_parent__c+P65","parentLabel":"formCheckbox_parentLabel__z5E44","parentErrorInform":"formCheckbox_parentErrorInform__9yM9K"};